module.exports = __webpack_public_path__ + "static/media/help.f8590436.svg";